<script lang="ts">
  import { mdiDeleteOutline } from "@mdi/js"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import ModalDialog from "@kontextwerk/web-sdk/ui/overlay/ModalDialog.svelte"

  const {
    organizationDisplayName,
    pending = false,
    onCancel,
    onConfirm,
  } = $props<{
    organizationDisplayName: string
    pending?: boolean
    onCancel: () => void
    onConfirm: () => Promise<void> | void
  }>()
</script>

<ModalDialog appearance="plain" title="Datenlöschung anfragen" onClose={onCancel} size="small">
  {#snippet content()}
    <div class="delete-dialog-content">
      <p>
        Wir leiten Ihre Anfrage an {organizationDisplayName} weiter. Die Kontaktdaten werden erst nach
        Prüfung gelöscht. Bis dahin werden die Kontaktwege für dieses Kontaktmittel deaktiviert.
      </p>
    </div>
  {/snippet}

  {#snippet footerSnippet()}
    <div class="actions">
      <CTA
        type="primaryButton"
        icon={mdiDeleteOutline}
        content={pending ? "Wird angefragt…" : "Datenlöschung anfragen"}
        onClick={onConfirm}
        disabled={pending}
        darkMode={false}
      />
    </div>
  {/snippet}
</ModalDialog>

<style lang="less">
  .delete-dialog-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    p {
      line-height: 1.45;
      margin: 0;
      color: var(--text-invers-100);
    }
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: flex-end;
  }
</style>
